@import '~style-sheet-helpers/core.less';

.insured-value-container {
  display: flex;
  margin-top: 10px;

  > :not(:last-child) {
    margin-right: 10px;
  }
}

.currency-input {
  margin-left: auto;
  width: 50%;
}
